import * as Yup from 'yup';
import i18n from '../../i18n';

// Helper function to get translated field name from translation key
const t = (key: string, params?: any): string => i18n.t(key, params) as string;

export const precheckPosFormSchema = () =>
  Yup.object({
    company: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.company') })),
    taxId: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.taxId') })),
    address: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.address') })),
    website: Yup.string().url(t('validation.invalidUrl')),
    director: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.director') })),
    contactPerson: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.contactPerson') })),
    email: Yup.string().email(t('validation.invalidEmail')).required(t('validation.fieldRequired', { field: t('merchant.email') })),
    telephone: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.telephone') })),
    onlineShop: Yup.string().url(t('validation.invalidUrl')),
    currentProvider: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.currentProvider') })),
    turnover: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.turnover') })),
    receiptSize: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.receiptSize') })),
    bankStatementReference: Yup.string().required(t('validation.fieldRequired', { field: t('merchant.bankStatementReference') })),
    cards: Yup.array().min(1, t('validation.selectAtLeastOne', { item: t('merchant.card') })),
  });
